import { Link } from 'react-router-dom';

import { ButtonBase } from '@mui/material';

import Logo from './Logo';

import config from 'themeConfig';

interface LogoSectionProps {
    sx?: object;
    to?: string;
}

const LogoSection = ({ sx, to }: LogoSectionProps) => (
    <ButtonBase disableRipple component={Link} to={to ?? config.defaultPath} sx={sx}>
        <Logo />
    </ButtonBase>
);

export default LogoSection;
